// extracted by mini-css-extract-plugin
module.exports = {"exam_rule_config_content_wrapper":"Content_exam_rule_config_content_wrapper__11-a5"};